import moment from 'moment-timezone';

export const getUserTimezone = (user) => user?.timezone || moment.tz.guess();

export const formatInUserTz = (date, user, format) =>
    moment.utc(date).tz(getUserTimezone(user)).format(format);

/** Convert a UTC ISO date string to a native Date whose local-time values match the user's timezone wall-clock. */
export const utcToUserTzDate = (utcDate, user) => {
    const m = moment.utc(utcDate).tz(getUserTimezone(user));
    return new Date(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());
};

/** Convert a native Date (whose local values represent user tz wall-clock) back to a UTC ISO string. */
export const userTzDateToUTC = (date, user) => {
    const tz = getUserTimezone(user);
    const m = moment.tz(
        { year: date.getFullYear(), month: date.getMonth(), day: date.getDate(), hour: date.getHours(), minute: date.getMinutes(), second: date.getSeconds() },
        tz
    );
    return m.utc().toISOString();
};
